__turbopack_context__.v({
  "bottomWrapper": "style-module-scss-module__B7j6SG__bottomWrapper",
  "callButton": "style-module-scss-module__B7j6SG__callButton",
  "content": "style-module-scss-module__B7j6SG__content",
  "copy": "style-module-scss-module__B7j6SG__copy",
  "mediaList": "style-module-scss-module__B7j6SG__mediaList",
  "navList": "style-module-scss-module__B7j6SG__navList",
  "subtitle": "style-module-scss-module__B7j6SG__subtitle",
  "title": "style-module-scss-module__B7j6SG__title",
  "wrapper": "style-module-scss-module__B7j6SG__wrapper",
});
